<!-- sections/FilterBySection.vue -->
<script setup lang="ts">
import BaseSection from '../components/BaseSection.vue';
import ConnxField, { ErrorUpdate } from '@/components/Molecules/Field/ConnxField.vue';
import { InputType } from '@/interfaces/InputFields';

interface Props {
  filters?: any[];
  errors?: Map<string, string | null>;
  showTitle?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  filters: () => [],
  errors: () => new Map(),
  showTitle: true,
});

const emit = defineEmits<{
  'field-error': [{ name: string; error: string | null }];
}>();

const handleFieldError = (error: ErrorUpdate) => {
  emit('field-error', error);
};
</script>

<template>
  <BaseSection title="Filter by" :should-show="filters && filters.length > 0" :show-title="showTitle">
    <div class="tw-p-2 tw-bg-connx-grey-tint-90">
      <div v-for="filterOption in filters" :key="filterOption.key">
        <ConnxField
          :name="filterOption.label"
          :label="filterOption.label"
          v-model="filterOption.value"
          :type="filterOption.multiselect ? InputType.MultiSelect : InputType.Select"
          :options="filterOption.values"
          @update:error="handleFieldError"
        />
      </div>
    </div>
  </BaseSection>
</template>
